<template>
  <div class="contact" id="contact">
    <div class="container">
      <div class="title">{{ $t('contact.titulo') }}</div>
      <div class="content">
        <div v-html="$t('contact.descripcion')" class="mb-35"></div>
        <div class="contact-block">
          <div>
            <div><input ref="name" type="text" v-model="name" :class="{'invalid': invalid.name}" @keyup="removeInvalid('name')" :placeholder="$t('contact.placeholder.nombre')"/></div>
            <div><input ref="email" type="email" v-model="email" :class="{'invalid': invalid.email}" @keyup="removeInvalid('email')" :placeholder="$t('contact.placeholder.email')"/></div>
          </div>
          <div>
            <textarea ref="message" v-model="message" :class="{'invalid': invalid.message}" @keyup="removeInvalid('message')" :placeholder="$t('contact.placeholder.mensaje')"></textarea>
          </div>
          <div class="text-left">
            <div v-html="$t('contact.textInfo')"></div>
          </div>
          <div class="accept-block">
            <span class="cursor-pointer" @click="checkInput()"><i :class="{'fas fa-square text-gris-claro': !checked && !invalid.check, 'fad fa-check-square text-gris': checked && !invalid.check, 'fal fa-square text-rojo': invalid.check}" class="fs-18 mr-10 bg-gris-claro"></i> {{ $t('contact.condiciones') }}</span>
          </div>
          <div class="button-block">
            <button :class="{'disable': disableButton, 'sent': sentButton, 'error': errorButton}" class="button-send" @click="sendForm()">
              <template v-if="sentButton && disableButton">{{ $t('contact.botones.enviado') }}</template>
              <template v-if="!sentButton && disableButton">{{ $t('contact.botones.enviando') }}</template>
              <template v-if="!sentButton && !disableButton">{{ $t('contact.botones.enviar') }}</template>
              <template v-if="errorButton">Error</template>
                <i v-if="sentButton && disableButton" class="fas fa-check"></i>
                <i v-if="!sentButton && disableButton" class="rotate fad fa-circle-notch"></i>
                <i v-if="!sentButton && !disableButton" class="fas fa-paper-plane"></i>
                <i v-if="errorButton" class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data: () => ({
    name: '',
    email: '',
    message: '',
    invalid: {
      name: false,
      email: false,
      message: false,
      check: false
    },
    checked: false,
    disableButton: false,
    sentButton: false,
    errorButton: false
  }),
  methods: {
    checkInput () {
      this.checked = !this.checked
      this.invalid.check = false
    },
    removeInvalid (field) {
      this.invalid[field] = false
    },
    validateForm () {
      let errors = Object.keys(this.$refs).reduce((accumulator, field) => {
        if (this.$refs[field].nodeName === 'INPUT' && this.$refs[field].type === 'text' && this.$refs[field].value.length === 0) {
          this.invalid.name = true
          return accumulator + 1
        }
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (this.$refs[field].nodeName === 'INPUT' && this.$refs[field].type === 'email' && (this.$refs[field].value.length === 0 || !re.test(this.$refs[field].value))) {
          this.invalid.email = true
          return accumulator + 1
        }
        if (this.$refs[field].nodeName === 'TEXTAREA' && this.$refs[field].type === 'textarea' && this.$refs[field].value.length === 0) {
          this.invalid.message = true
          return accumulator + 1
        }
        return accumulator
      }, 0)

      /* if (!this.checked) {
        this.invalid.check = true
        errors += 1
      } */

      return errors
    },
    sendForm () {
      if (this.disableButton === true) {
        return false
      }
      this.disableButton = true
      if (this.validateForm() === 0) {
        // SEND
        const formData = {
          name: this.name,
          email: this.email,
          message: this.message,
          acceptCommercial: this.checked
        }
        const url = `${window.location.origin}${window.location.pathname}static/scripts/api.php`
        this.$http.post(url, formData, {emulateJSON: true}).then(response => {
          // success callback
          if (response.status !== 200) {
            this.errorButton = true
          }
          if (response.body === 'OK') {
            this.sentButton = true
          }
          if (response.body !== 'OK') {
            this.errorButton = true
          }
        }, response => {
          // error callback
          this.errorButton = true
        })
      }
      if (this.validateForm() > 0) {
        this.disableButton = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contact {
  position: relative;
  width: 100%;
  background: url(../assets/bg-origin.png) no-repeat center center;
  background-size: cover;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  * {
    box-sizing: border-box;
  }

  .container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 10px;
    padding-bottom: 60px;

    > div {
      width: 100%;
    }

    .title {
      margin-bottom: 30px;
      font-weight: 700;
      font-size: 36px;
      color: #444D67;
    }

    .content {
      font-size: 16px;
      max-width: 750px;
      margin: 0 auto;
      line-height: 170%;
      color: #6e6e6e;

      .contact-block {

        > div {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;

          &:first-child > div {
            width: calc(100% - 5px);

            &:first-child {
              margin-right: 10px;
            }
          }
        }
        input, textarea {
          width: 100%;
          border: none;
          outline: none;
          padding: 21px 20px 19px;
          font-family: 'OpenSans';
          font-size: 16px;
          background: #F3F3F3;
          border-radius: 8px;
        }

        textarea {
          resize: none;
          height: 150px;
        }

        textarea::-webkit-scrollbar {
          background-color: #dfe6e9;
          border-radius: 9px;
          cursor: pointer;
          overflow: hidden;
          width: 9px;
        }

        textarea::-webkit-scrollbar-thumb {
          background-color: #95a5a6;
          border-radius: 9px;
        }

        textarea::-webkit-scrollbar-track {
          background-color: #dfe6e9;
          opacity: 0;
        }

        .accept-block {
          text-align: left;
          i {
            width: 16px;
            height: 16px;
          }
        }

        .button-block {
          margin-top: 30px;
          display: flex;
          justify-content: center;

          .button-send {
            display: flex;
            align-items: center;
            height: 50px;
            padding-left: 20px;
            padding-right: 20px;
            background: #4AC4D0;
            font-size: 20px;
            font-weight: 600;
            color: #fff;
            border-radius: 8px;
            border: none;
            outline: none;
            cursor: pointer;

            i {
              position: relative;
              width: 24px;
              height: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 12px;
              margin-left: 30px;
              background: #40abb5;
              border-radius: 6px;

              &.rotate:before,
              &.rotate:after {
                animation: rotate 2s infinite linear;
              }

              @keyframes rotate {
                0% {
                  transform: rotate(0deg);
                }
                100% {
                  transform: rotate(360deg);
                }
              }
            }

            &.disable {
              opacity: 0.5;
              cursor: not-allowed;

              &.sent {
                opacity: 1;
              }
            }

            &.error {
              background: #d02f2f !important;
              opacity: 1 !important;

              i {
                background: #a70808 !important;
              }
            }
          }
        }

        .invalid {
          -webkit-box-shadow:inset 0 0 0 1px #FF0D0D;
          box-shadow:inset 0 0 0 1px #FF0D0D;
        }
      }

    }
  }
}

@media(max-width: 1200px) {
  .contact .container {
    font-size: 14px;

    .content {
      font-size: 14px;
    }
  }
}

@media(max-width: 1150px) {
  .contact .container {
    font-size: 14px;
    .title {
      font-size: 32px;
    }
  }
}

@media(max-width: 900px) {
  .contact .container {
    .title {
      font-size: 28px;
    }
  }
}

@media(max-width: 770px) {
  .contact .container {
    .content .contact-block > div:first-child {
      flex-wrap: wrap;
      margin-bottom: 0;

      div,
      div:first-child {
        width: 100%;
        margin-right: 0;
        margin-bottom: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue